import { FC, useMemo } from 'react'
import Figures, { FiguresProps } from 'src/components/Figures'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import {
  ImageTransformer,
  unwrapMedia,
} from 'src/relay/Transformers/ImageTransformer'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'
import { ActionIconBackground } from '../../../components/ActionButton/types'

import { DetailedStatisticBlockProps } from './props'

const DetailedStatisticBlock: FC<BlockProps<DetailedStatisticBlockProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const props: FiguresProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          ...(data.sectionTitle && {
            tag: data.sectionTitle,
          }),
          title: data.title,
        },
      }),
      color: getThemeColor(data.theme?.data),
      subtitle: data.subtitle,
      ...(data.description && {
        richTextProps: RichTextTransformer(
          data.description,
          configuration,
          locale
        ),
      }),
      actionButtonProps: ButtonTransformer({
        data: data.cta,
        theme: data.theme?.data,
        iconBackground: ActionIconBackground.color,
      }),
      nextImageProps: {
        imageProps: ImageTransformer(unwrapMedia(data.desktopImage), {
          tablet: '100vw',
          desktop: '50vw, 75vw',
        }),
        mobileImageProps: ImageTransformer(unwrapMedia(data.mobileImage), {
          tablet: '100vw',
          desktop: '50vw, 75vw',
        }),
      },
      cards: data.keyStat?.map((stat) => ({
        data: [stat.mainStat, stat.secondaryNumber],
        complement: stat.description,
      })),
    }),
    [configuration, data, locale]
  )

  return <Figures {...props} />
}

export default DetailedStatisticBlock
